import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getIsAuth } from '@/entities/Admin';
import { useGetMyNotificationsUnreadCountQuery } from '@/entities/MyNotifications';
import { routerPath } from '@/shared/config/router';
import { LocalStorageService } from '@/shared/services/localStorage.service';
import { Svg } from '@/shared/ui/Svg';
import NotificationIcon from '@/shared/assets/icons/notification-icon.svg';
import styles from './NotificationLink.module.scss';

export const NotificationLink = () => {
  const isAuth = useSelector(getIsAuth);
  const accessToken = LocalStorageService.getAccessToken();

  const { data } = useGetMyNotificationsUnreadCountQuery(undefined, {
    skip: !isAuth && !accessToken,
  });

  const unreadCount = data?.count ?? 0;

  return (
    <Link
      to={routerPath.myNotifications}
      className={styles.root}
      aria-label={unreadCount > 0 ? `Notifications, ${unreadCount} unread` : 'Notifications'}
    >
      <Svg Icon={NotificationIcon} width={48} height={48} />
      {unreadCount > 0 ? (
        <span className={styles.badge} aria-hidden>
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      ) : null}
    </Link>
  );
};
